import { useEffect } from 'react';
import { SITE_URL } from './siteConfig';

const upsert = (selector, make) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = make();
    document.head.appendChild(el);
  }
  return el;
};

const meta = (attr, key, content) => {
  upsert(`meta[${attr}="${key}"]`, () => {
    const m = document.createElement('meta');
    m.setAttribute(attr, key);
    return m;
  }).setAttribute('content', content);
};

export const setRobots = (index) => meta('name', 'robots', index ? 'index, follow' : 'noindex, nofollow');

export const applySeo = ({ title, description, path }) => {
  const url = `${SITE_URL}${path}`;
  document.title = title;
  meta('name', 'description', description);
  meta('property', 'og:title', title);
  meta('property', 'og:description', description);
  meta('property', 'og:url', url);
  meta('name', 'twitter:title', title);
  meta('name', 'twitter:description', description);
  upsert('link[rel="canonical"]', () => {
    const l = document.createElement('link');
    l.setAttribute('rel', 'canonical');
    return l;
  }).setAttribute('href', url);
  setRobots(true);
};

export const useSeo = ({ title, description, path }) => {
  useEffect(() => applySeo({ title, description, path }), [title, description, path]);
};

export const setJsonLd = (id, data) => {
  upsert(`script#${id}`, () => {
    const s = document.createElement('script');
    s.type = 'application/ld+json';
    s.id = id;
    return s;
  }).textContent = JSON.stringify(data);
};
